<template>
  <div class="p-3">
    <!-- Score entry view -->
    <div v-if="activeEvaluation">
      <h6 class="font-weight-bold mb-3">
        {{ activeEvaluation.exam_name }} — {{ activeEvaluation.course_code }} - {{ activeEvaluation.course_name }}
        (Round {{ activeEvaluation.evaluator_number }})
      </h6>
      <FacultyCoeEvaluateStudents
        :exam-id="activeEvaluation.end_sem_exam_id"
        :grouped-course-id="activeEvaluation.grouped_course_id"
        :evaluator-number="activeEvaluation.evaluator_number"
      />
    </div>

    <!-- Assignment list -->
    <template v-else>
      <div v-if="errorMessage" class="text-danger small mb-2">{{ errorMessage }}</div>

      <div class="loading" v-if="fetchData">
        <load-data></load-data>
      </div>

      <div v-else>
        <div v-if="!evaluations.length" class="text-muted small py-2">
          No evaluations assigned to you.
        </div>

        <div v-else class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead class="thead-dark">
              <tr>
                <th>Exam</th>
                <th>Course</th>
                <th style="width:100px">Round</th>
                <th>Students</th>
                <th style="width:120px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="evaluation in evaluations" :key="evaluationKey(evaluation)">
                <td>{{ evaluation.exam_name }}</td>
                <td>{{ evaluation.course_code }} - {{ evaluation.course_name }}</td>
                <td>Round {{ evaluation.evaluator_number }}</td>
                <td>
                  <span v-if="!evaluation.students.length" class="text-muted">No students assigned yet.</span>
                  <span v-else>{{ evaluation.students.map(s => s.name).join(', ') }}</span>
                </td>
                <td>
                  <b-button
                    v-if="evaluation.students.length"
                    size="sm"
                    variant="primary"
                    @click="openEvaluation(evaluation)"
                  >
                    Evaluate
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import FacultyCoeEvaluateStudents from "./FacultyCoeEvaluateStudents.vue";

export default {
  name: "FacultyCoeEvaluations",

  components: { FacultyCoeEvaluateStudents },

  data() {
    return {
      fetchData: false,
      errorMessage: "",
      evaluations: [],
      activeEvaluation: null,
    };
  },

  async mounted() {
    await this.fetchEvaluations();
  },

  methods: {
    evaluationKey(evaluation) {
      return `${evaluation.end_sem_exam_id}-${evaluation.grouped_course_id}-${evaluation.evaluator_number}`;
    },

    openEvaluation(evaluation) {
      this.activeEvaluation = evaluation;
      this.$emit(
        "breadcrumb-change",
        `${evaluation.exam_name} — ${evaluation.course_code} - ${evaluation.course_name} (Round ${evaluation.evaluator_number})`
      );
    },

    // Called by the parent's back-icon chain. Returns true if it navigated back
    // a level itself (parent should not go back further), false if already at
    // the assignment list.
    goBack() {
      if (this.activeEvaluation) {
        this.activeEvaluation = null;
        return true;
      }
      return false;
    },

    async fetchEvaluations() {
      this.fetchData = true;
      this.errorMessage = "";
      try {
        const mainAPI = this.$store.getters.getAPIKey.mainAPI;
        const res = await this.$axios.get(`${mainAPI}/faculty/evaluations`);
        this.evaluations = res.data.data || [];
      } catch {
        this.errorMessage = "Failed to load your assigned evaluations.";
      } finally {
        this.fetchData = false;
      }
    },
  },
};
</script>
